import React from 'react';
var context = React.createContext(null);
context.displayName = 'AccordionContext';
export default context;